module.exports = __webpack_public_path__ + "assets/img/news (27).f3289ddf.png";